import { BG_SCHEMA, TITLE_SCHEMA, SUBTITLE_SCHEMA } from '../common/content'
import { commonBeforeParseMethod, commonGetIdMethod } from '../helpers'

export const TESTIMONIALS_ITEM_OPTION = () => ({
  company: 'Empresa',
  name: 'Nome',
  text: 'Depoimento...',
  visible: false
})

export const TESTIMONIALS_SCHEMA = config => {
  const {id, idLayout, pageId} = commonGetIdMethod(config)

  return {
    type: 'testimonials',
    id: id,
    idLayout: idLayout,
    pageId: pageId,
    name: '',
    title: TITLE_SCHEMA('Depoimentos'),
    subtitle: SUBTITLE_SCHEMA(),
    bg: BG_SCHEMA(),
    items: [TESTIMONIALS_ITEM_OPTION()],
  }
}

export const beforeParseTestimonials = target => {
  commonBeforeParseMethod(target)
}

export const TESTIMONIALS_SECTION = config => ({
  schema: TESTIMONIALS_SCHEMA(config),
  beforeParse: beforeParseTestimonials
})
